"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarkModeSwitch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useConstCallback_1 = require("powerhooks/useConstCallback");
var index_1 = require("./lib/index");
var Brightness4_1 = __importDefault(require("@mui/icons-material/Brightness4"));
var Brightness7_1 = __importDefault(require("@mui/icons-material/Brightness7"));
var Icon_1 = require("./Icon");
var IconButton_1 = require("./IconButton");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var Icon = Icon_1.createIcon({
    "darkModeIcon": Brightness4_1.default,
    "lightModeIcon": Brightness7_1.default,
}).Icon;
var IconButton = IconButton_1.createIconButton({ Icon: Icon }).IconButton;
exports.DarkModeSwitch = react_1.memo(function (props) {
    var className = props.className, size = props.size;
    var _a = index_1.useIsDarkModeEnabled(), isDarkModeEnabled = _a.isDarkModeEnabled, setIsDarkModeEnabled = _a.setIsDarkModeEnabled;
    var onClick = useConstCallback_1.useConstCallback(function () {
        setIsDarkModeEnabled(!isDarkModeEnabled);
    });
    var _b = useStyles(), classes = _b.classes, cx = _b.cx;
    return (jsx_runtime_1.jsx(IconButton, { className: cx(classes.root, className), onClick: onClick, size: size, iconId: isDarkModeEnabled ? "lightModeIcon" : "darkModeIcon", "aria-label": "Dark mode switch" }, void 0));
});
var useStyles = ThemeProvider_1.makeStyles({ "name": { DarkModeIcon: Brightness4_1.default } })(function (theme) { return ({
    "root": {
        "transition": "transform 500ms",
        "transform": "rotate(" + (theme.isDarkModeEnabled ? 180 : 0) + "deg)",
        "transitionTimingFunction": "cubic-bezier(.34,1.27,1,1)",
    },
}); });
//# sourceMappingURL=DarkModeSwitch.js.map